import { ApiClient } from '@wix/gg-components';

export const apiClient = new ApiClient({
  baseURL: typeof window !== 'undefined' ? window.__BASEURL__ || '' : '',
});
